import { render } from "./AppArrowButton.vue?vue&type=template&id=7a7b980b&scoped=true"
import script from "./AppArrowButton.vue?vue&type=script&lang=js"
export * from "./AppArrowButton.vue?vue&type=script&lang=js"

import "./AppArrowButton.vue?vue&type=style&index=0&id=7a7b980b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a7b980b"]])

export default __exports__